import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  Divider,
  useTheme,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  Person as PersonIcon,
  Work as WorkIcon,
  Badge as BadgeIcon,
} from "@mui/icons-material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from "react-router-dom";

const CandidateInfoCard = ({ candidate, details }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Card
      elevation={2}
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        boxShadow:
          theme.palette.mode === "dark"
            ? "0px 1px 3px rgba(0, 0, 0, 0.3)"
            : "0px 1px 3px rgba(0, 0, 0, 0.1)",
        borderRadius: 3,
      }}
    >
      <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Typography
          variant="body1"
          sx={{ fontWeight: 600, mb: 2}}
        >
          Candidate & Interview Information
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center",  minWidth: 0 }}>
          <Avatar
            sx={{
              width: 42,
              height: 42,
              bgcolor: theme.palette.primary.main,
              mr: 1,
            }}
          >
            <PersonIcon sx={{ fontSize: 30 }} />
          </Avatar>
          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                color: theme.palette.text.primary,
                overflowWrap: "anywhere",
              }}
            >
              {candidate.name}
            </Typography>
            <Typography
                variant="caption"
                sx={{ fontWeight: 500, color: theme.palette.text.secondary, overflowWrap: "anywhere" }}
              >
                {candidate.position}
              </Typography>
            {/* <Typography
              variant="caption"
              color="text.secondary"             
              sx={{ overflowWrap: "anywhere"}}
            >
              {candidate.email}
            </Typography> */}
          </Box>
        </Box>

        <Divider sx={{ my: 1.5 }} />

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
              md: "repeat(5, minmax(0, 1fr))",
            },
            gap: 1.5,
          }}
        >
          {/* <Box sx={{ display: "flex", alignItems: "center", minWidth: 0 }}>
            <WorkIcon
              sx={{ fontSize: 20, color: theme.palette.text.secondary, mr: 1.5 }}
            />
            <Box sx={{ minWidth: 0 }}>
              <Typography
                variant="caption"
                color="text.secondary"
                display="block"
              >
                Position
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: 500, color: theme.palette.text.primary, overflowWrap: "anywhere" }}
              >
                {candidate.position}
              </Typography>
            </Box>
          </Box> */}

          {details && (
            <>
              <Box sx={{ minWidth: 0 }}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                  sx={{ mb: 0.5 }}
                >
                  Interview Date
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 500, color: theme.palette.text.primary, overflowWrap: "anywhere" }}
                >
                  {details.date}
                </Typography>
              </Box>

              <Box sx={{ minWidth: 0 }}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                  sx={{ mb: 0.5 }}
                >
                  Total Duration
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 500, color: theme.palette.text.primary, overflowWrap: "anywhere" }}
                >
                  {details.duration}
                </Typography>
              </Box>

              <Box sx={{ minWidth: 0 }}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                  sx={{ mb: 0.5 }}
                >
                  Total Behaviour Score
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 500,
                    color: theme.palette.text.primary,
                    overflowWrap: "anywhere",
                  }}
                >
                  {details.totalBehaviourScore != null
                    ? details.totalBehaviourScore: "0"}/5
                </Typography>
              </Box>

              <Box sx={{ minWidth: 0 }}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                  sx={{ mb: 0.5 }}
                >
                  Total AI Response Score
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 500,
                    color: theme.palette.text.primary,
                    overflowWrap: "anywhere",
                  }}
                >
                  {details.totalAiScore != null ? details.totalAiScore: "0"}/5
                </Typography>
              </Box>
              <Box sx={{ minWidth: 0 }}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                  sx={{ mb: 0.5 }}
                >
                  Questions Answered
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 500, color: theme.palette.text.primary, overflowWrap: "anywhere" }}
                >
                  {details.questionsAnswered}
                </Typography>
              </Box>
              {/* <Box sx={{ minWidth: 0 }}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                  sx={{ mb: 0.5 }}
                >
                  View Logs
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 500, color: theme.palette.text.primary, overflowWrap: "anywhere" }}
                >                
                   <VisibilityIcon color="primary" sx={{ mr: 0.4,cursor: "pointer"}} o
                   onClick={() => navigate(`/view-logs/${details.interviewId}`, 
                   { state: {candidateData: candidate } }  )} />
                </Typography>
              </Box> */}
            </>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default CandidateInfoCard;
